<template>
  <section class="current-table sans mx-auto max-width">
    <div class="mx2 sm-mx3">
      <router-link
        v-for="(item, index) in itemsFiltered"
        :key="index"
        :to="{ name: 'Events', params: { slug: item.slug } }"
        class="clearfix max-width pb1 border-top py2 display-block"
      >
        <div class="col col-3 xs-hide pr2">
          <span class="tabular"
            >{{ formatDate(item.start.date) }} –
            {{ formatDate(item.end.date) }}</span
          >
          <div class="mt1">
            <span class="badge caps fs-s" v-if="dateIsBefore(item.start.date)"
              >Upcoming</span
            >
            <span
              class="badge caps fs-s red"
              v-else-if="dateIsBefore(item.end.date)"
              >Now</span
            >
          </div>
        </div>
        <div class="col col-12 sm-col-7 relative">
          <div class="col-8 sm-col-12">
            <div class="hover-red">{{ item.title }}</div>
            <em>{{ item.venue }}</em>
            <div class="mt1 sm-hide md-hide lg-hide tabular">
              {{ formatDate(item.start.date) }} –
              {{ formatDate(item.end.date) }}
            </div>
          </div>
          <div class="sm-hide md-hide lg-hide absolute top-right">
            <span class="badge caps fs-s" v-if="dateIsBefore(item.start.date)"
              >Upcoming</span
            >
            <span
              class="badge caps fs-s red"
              v-else-if="dateIsBefore(item.end.date)"
              >Now</span
            >
          </div>
        </div>
        <div class="col col-2 xs-hide sm-hide md-show lg-show right-align">
          <span v-text="exhibitionDistance(item)"></span>
        </div>
      </router-link>
      <div
        v-if="!showAllCurrent && this.content.length > this.showNum"
        @click="show"
        class="button py2 px3 mt-16 pointer block red"
      >
        {{ showMoreTitle }}
      </div>
    </div>
  </section>
</template>

<script>
import { formatDate, exhibitionDistance } from '@/utils'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Current',

  data() {
    return {
      showNum: 3,
    }
  },

  props: ['title', 'content'],

  methods: {
    ...mapActions(['showCurrent']),
    exhibitionDistance,
    formatDate,
    show() {
      this.showCurrent()
    },
  },

  computed: {
    ...mapState(['showAllCurrent']),
    itemsFiltered() {
      if (!this.showAllCurrent) {
        return this.content.slice(0, this.showNum)
      } else {
        return this.content
      }
    },
    showMoreTitle() {
      return `Show ${this.content.length - this.showNum} More...`
    },
  },
}
</script>

<style lang="css" scoped>
.current-table {
  line-height: var(--line-height-reader);
  margin-bottom: 5em;

  a:hover .hover-red {
    color: var(--red);
  }

  a:last-child {
    border-bottom: 1px solid var(--black);
  }
}
</style>
